import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import TransferIcon from '@app/images/transfer.svg';
import ArrowsIcon from '@app/images/arrows.svg';
import { PingPongUSDFormDetails } from './PingPongUSDAfterForm';

export const NiumFormDetails: InstructionFormDetails = {
  ...PingPongUSDFormDetails,
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.transferMustBe',
      'supplierValidation.afterRegister.pingPongUSD.transferShouldBe',
      'supplierValidation.afterRegister.invoice',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: [
    { icon: TransferIcon, text: 'supplierValidation.afterRegister.pingPongUSD.step1' },
    { icon: ArrowsIcon, text: 'supplierValidation.afterRegister.pingPongUSD.step2' },
  ],
};
